


















































































































































import { Component, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";
import "@/plugins/metaHeadful";
import VueFormulate from '@braid/vue-formulate';
import { it, en } from '@braid/vue-formulate-i18n';
import { submitContactForm } from '@/helpers/requests/contact-form';
import { router } from '@/router';


Vue.use(VueFormulate, {
  plugins: [it, en]

})


@Component
export default class FooterNewsletter extends Vue {

  title: string = '';
  checkbox: boolean = false;
  email?: string = '';
  name: string = '';
  message: string = '';
  handleRoute = UtilitiesFunctions.handleRoute;
  on: any = {};

  created() {
    // api here
    this.title = "Newsletter";
  }

  resetCheckbox() {
    const email: any = document.getElementById("mce-EMAIL");
    setTimeout(() => {
      if (email) {
        // console.warn(email.getAttribute("value"));
        email.value = "";
        this.checkbox = false;
      }
    }, 1000);
  }

  async submitClicked() {
    await this.$store.dispatch("session/setLoading", true);
    const response: Response = await submitContactForm({
      name: this.name,
      email: this.email,
      message: this.message
    })
    await this.$store.dispatch("session/setLoading", false);
    if (response.ok) {
      await this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t('contacts.submitSuccess'),
        color: "green"
      });
      await router.replace('/');
    } else {
      await this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t('contacts.submitFailure'),
        color: "red"
      });
    }
    return false;
  }

}

